import { camelCase } from 'lodash';

export default function parseCSSExports(exports) {
  const parsedExports = {};

  Object.entries(exports).map(([key, value]) => {
    const [group, variableName] = key.split('__').map(camelCase);

    if (!parsedExports[group]) {
      parsedExports[group] = {};
    }

    parsedExports[group][variableName] = value;
  });

  return parsedExports;
}
